export enum DYNAMIC_PATH {
  NEW = 'new',
  EDIT = 'edit',
  SILO_ID = ':siloID',
  USER_ID = ':userID',
  STOCK = 'stock',
  DEVICE = 'device',
  ALERT = 'alert',
  ACTIVITY = 'activity',
  NOTIFICATION = 'notification/:userID',
  STATE_STOCK = 'state-stock',
  EXISTENCE_STOCK = 'existence-report',
  INSURANCE = 'insurance/:siloIDs',
  CORVUS = 'corvus/:siloID',
  POSITION_GENERAL = 'position-general',
  TEXT = ':text',
  SILOMETRIX_THRESHOLD = 'metrics_alerts_config',
  WARRANTS = 'warrants',
  ARCHIVED = 'archived',
}

export enum PATH {
  // PUBLIC
  LOGIN = '/login', // ✅ PARA ACCEDER A UNA CUENTA DE USUARIO
  SIGNIN = '/signin', // ✅ Nueva pantalla de ingreso con proveedores
  AUTH_CALLBACK = '/auth/callback', // ✅ Callback genérico de OAuth
  NO_CONNECTION = '/no-connection', // ✅ PANTALLA PARA DISPOSITIVOS SIN INTERNET
  ERROR = '/error', // ✅ Página de error pública
  FORGOT_PASSWORD = '/forgot-password', // ✅ RECUPERACIÓN DE PW OLVIDADA
  VERIFY_REGISTER = '/verify-register', // ✅ ES PARA VERIFICAR REGISTRO DE EMPRESAS
  REGISTER = '/register', // ✅ ES PARA REGISTRO DE EMPRESAS (nueva organización)
  REGISTER_PLASTAR = '/go/plastar', // ✅ ES PARA REGISTRO DE EMPRESAS (nueva organización)
  REGISTER_NERA = '/go/nera', // ✅ ES PARA REGISTRO DE EMPRESAS (nueva organización)
  REGISTER_AGROLOGY = '/go/agrology', // ✅ ES PARA REGISTRO DE EMPRESAS (nueva organización)
  REGISTER_LARTIRIGOYEN = '/go/lartirigoyen', // ✅ ES PARA REGISTRO DE EMPRESAS (nueva organización)
  REGISTER_EDP = '/go/edp-agro', //✅ ES PARA REGISTRO DE EMPRESAS (nueva organización)
  ONBOARDING = '/onboarding', // 🏗️ Nuevo flujo de alta para usuarios sin registro previo
  COMPLETE_REGISTER = '/complete-register', // ✅ REGISTRO EXITOSO DE EMPRESA
  VERIFY_RESET_ACCOUNT = '/verify-reset-account', // ✅ PONER EMAIL Y CÓDIGO ENVIADO POR MAIL
  RESET = '/reset', // ✅ AL PONER BIEN EL CÓDIGO, PERMITE PONER NUEVA CONTRASEÑA

  // PROTECTED
  DASHBOARD = '/dashboard', // ✅ página principal
  SILOBAG = '/silobag', // ✅ listado legacy de sb
  SILOBAG_V2 = '/v2/silobag-list', // ✅ refactor listado de sb
  SILO_PERMISSION = 'silobags_permissions/predictive',
  SILOBAG_DETAIL = `${PATH.SILOBAG}/${DYNAMIC_PATH.SILO_ID}`, // ✅ detalle de sb
  SILOBAG_NEW = `${PATH.SILOBAG}/${DYNAMIC_PATH.NEW}`, // ✅ crear nuevo sb
  SILOBAG_EDIT = `${PATH.SILOBAG}/${DYNAMIC_PATH.SILO_ID}/${DYNAMIC_PATH.EDIT}`, // ✅ editar sb
  ADMINISTRATOR = '/admin', // ✅ dashboard de Administración
  ADMIN_NOTIFICATION = `${PATH.ADMINISTRATOR}/${DYNAMIC_PATH.NOTIFICATION}`, // ✅ panel de notificaciones de admin
  NOTIFICATION = '/user-notification',
  USER_NOTIFICATION = `${PATH.NOTIFICATION}/${DYNAMIC_PATH.USER_ID}`,
  MAP = '/map', // ✅ el mapa
  REPORT = '/report', // ✅ reportes
  REPORT_STOCK = `${PATH.REPORT}/${DYNAMIC_PATH.STOCK}`, // ✅ reporte de stock
  REPORT_DEVICE = `${PATH.REPORT}/${DYNAMIC_PATH.DEVICE}`, // ✅ reporte de dispositivos
  REPORT_ALERT = `${PATH.REPORT}/${DYNAMIC_PATH.ALERT}`, // ✅ reporte de alertas
  REPORT_ACTIVITY = `${PATH.REPORT}/${DYNAMIC_PATH.ACTIVITY}`, // ✅ reporte de actividades
  REPORT_STATE_STOCK = `${PATH.REPORT}/${DYNAMIC_PATH.STATE_STOCK}`, // ✅ reporte de estado de stock
  REPORT_SAT_SILOBAGS_EXISTENCE = `${PATH.REPORT}/${DYNAMIC_PATH.EXISTENCE_STOCK}`, // reporte de existencia de stock
  REPORT_POSITION_GENERAL = `${PATH.REPORT}/${DYNAMIC_PATH.POSITION_GENERAL}`, // ✅ reporte de posición general
  SILOBAG_INSURANCE = `${PATH.SILOBAG}/${DYNAMIC_PATH.INSURANCE}`, // ✅ seguro de sb
  INCONSISTENCIES = '/inconsistencies',
  // SILO_PERMISSION_PREDICTIVE = `${PATH.SILO_PERMISSION}/${DYNAMIC_PATH.TEXT}`,
  // WAITING FOR DELETE
  ALERT = '/alert', // ❌ Dpersonalización de alertas (?) // desestimado (umbral de alertas)
  NAV = '/nav', // ❌ ESTO ES FALOPA DE LA BUENA
  SILOBAG_MAP = '/silobag/map', // ❌ se está usando siempre countryside (nueva ruta para el map)
  VIEW_SILO = '/silobag/:id', // ❌ repetido
  VERIFY = '/verify', // ❌ revisar más a fondo
  VERIFY_ACCOUNT = '/verify-account', // ❌ revisar más a fondo
  NOT_FOUND = '*', // ❌ (?) // no carga
  SILOMETRIX_THRESHOLD = `${PATH.ADMINISTRATOR}/metrics_alerts_config`,
  WARRANTS = `${PATH.ADMINISTRATOR}/warrants`,
}
